import React, { memo } from 'react';
import theme from './style';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Grid, withWidth } from '@material-ui/core';
import toMoney from '../../../misc/serializeToMoney'
import translate from '../../../misc/applyTranslation';
import {
  downloadSupplierInvoicePDF,
  openPendingPDFWindow,
  triggerPDFOpen,
} from '../../../redux/actions/supplierInvoices';
import { useConfig } from "../../../context/configContext";
const OutboundInvoice = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const {
    customer_id,
    data,
    width,
    access_token,
    refresh_token,
    downloadSupplierInvoicePDF
  } = props;

  const handlePDFDownload = (id) => {
    const previewWindow = openPendingPDFWindow();
    downloadSupplierInvoicePDF({
      access_token,
      refresh_token,
      id: id,
      type: 'pdfSupplierInvoice',
      customer_id
    }).then(res => {
      try {
        triggerPDFOpen(res, previewWindow);
      } catch (error) {
        if (previewWindow) {
          previewWindow.close();
        }
      }
    })
  }

  let responsiveTest = (width === 'xs' || width === 'sm');
  if (!responsiveTest) {
    return (
      <React.Fragment>
        <TableContainer component={Paper} className={classes.container} >
          <Table className={classes.table} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>{translate('supplier-invoices', 'table_header_supplier')}</TableCell>
                <TableCell>{translate('supplier-invoices/detail', 'table_header_invoice_number')}</TableCell>
                <TableCell>{translate('supplier-invoices/detail', 'table_header_invoice_day')}</TableCell>
                <TableCell>{translate('supplier-invoices/detail', 'table_header_due_day')}</TableCell>
                <TableCell>{translate('supplier-invoices', 'table_header_amount')}</TableCell>
                <TableCell>{translate('supplier-invoices', 'table_header_supplier_invoice_view_pdf')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.supplier_invoice_id}>
                  <TableCell>{row.suppl_name}</TableCell>
                  <TableCell>{row.sup_inv_nr}</TableCell>
                  <TableCell>{row.sup_inv_day}</TableCell>
                  <TableCell>{row.sup_due_day}</TableCell>
                  <TableCell>{toMoney(row.amount_total)}</TableCell>
                  <TableCell align='center' className='pointer' onClick={() => handlePDFDownload(row.supplier_invoice_id)}><img src='/pdf-file.png' alt='PDF' /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </React.Fragment>
    );
  } else {
    return <div style={{ minHeight: 20, marginBottom: 20 }}>

      {data.map((row) => (
        <Grid container key={row.supplier_invoice_id} className={classes.responsiveContainer}>
          <Grid item xs={6} className={classes.leftCol}>
            <div className={classes.kvRow}><span className={classes.kvLabel}>{translate('supplier-invoices', 'table_header_supplier')}</span><span className={classes.kvValue}>{row.suppl_name}</span></div>
            <div className={classes.kvRow}><span className={classes.kvLabel}>{translate('supplier-invoices/detail', 'table_header_invoice_number')}</span><span className={classes.kvValue}>{row.sup_inv_nr}</span></div>
            <div className={classes.kvRow}><span className={classes.kvLabel}>{translate('supplier-invoices/detail', 'table_header_invoice_day')}</span><span className={classes.kvValue}>{row.sup_inv_day}</span></div>
          </Grid>

          <Grid item xs={4} className={classes.midCol}>
            <div className={classes.kvRow}><span className={classes.kvLabel}>{translate('supplier-invoices/detail', 'table_header_due_day')}</span><span className={classes.kvValue}>{row.sup_due_day}</span></div>
            <div className={classes.kvRow}><span className={classes.kvLabel}>{translate('supplier-invoices', 'table_header_amount')}</span><span className={classes.kvValue}>{toMoney(row.amount_total)}</span></div>
          </Grid>

          <Grid item xs={2} className={classes.rightCol}>
            <button className={classes.pdfIcon} onClick={() => handlePDFDownload(row.supplier_invoice_id)} aria-label="Open PDF">
              <img src='/pdf-file.png' alt='PDF' />
            </button>
          </Grid>
        </Grid>
      )
      )}
    </div>
  }
}
OutboundInvoice.propTypes = {
  data: PropTypes.string.isRequired,
}

const mapStateToProps = store => ({
  access_token: store.login.access_token,
  refresh_token: store.login.refresh_token,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    downloadSupplierInvoicePDF
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(memo(OutboundInvoice)));
